import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import "es6-promise/auto";
import EchoInstance from "@/echo.js";
import { i18n } from '@/plugins/i18n.js'
import unauthorizedInterceptor from "@/unauthorized-interceptor.js";

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueResource);
Vue.http.options.credentials = true;
Vue.http.interceptors.push(unauthorizedInterceptor(store, router));

window.io = require("socket.io-client");
window.Echo = EchoInstance.getInstance();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
